import { useQuery } from '@apollo/client';
import {
  ContentRepositoriesByOrgResponse,
  GET_CONTENT_REPOSITORIES_By_ORGANISATION,
} from '../../../apollo/queries/organisations/contentRepositores.queries';

const useContentRepositoriesByOrgAPI = (organization: string) => {
  const { loading, data } = useQuery<ContentRepositoriesByOrgResponse>(
    GET_CONTENT_REPOSITORIES_By_ORGANISATION,
    {
      variables: { organization },
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
    },
  );

  return {
    loading,
    contentRepositories: (data && data.contentRepositories) || [],
  };
};

export default useContentRepositoriesByOrgAPI;
